'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useAuth } from '@/contexts/auth-context';
import { LoadingSpinner } from '@/components/ui/loading-spinner';

/**
 * Client component that handles auth redirect for homepage.
 * This allows the main page to be a server component for better performance.
 * Shows a loading state while checking auth to prevent homepage flash.
 */
export function HomepageAuthRedirect() {
  const { user, loading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (!loading && user) {
      router.push('/dashboard');
    }
  }, [user, loading, router]);

  // Don't render anything - just handle redirect logic
  // We prefer a flash of content for unauthenticated users (better SEO/UX for new visitors)
  // over showing a spinner to everyone.
  if (loading) {
    return null;
  }

  // Only show spinner if we have a user and are redirecting
  if (user) {
    return <LoadingSpinner message="Redirecting to dashboard..." />;
  }

  return null;
}
